import {
  signIn,
  signUp,
  confirmSignUp,
  fetchAuthSession,
  getCurrentUser,
  confirmSignIn
} from "aws-amplify/auth";

import { MESSAGES } from "../../Utils/ErrorMessages";


async function loginUser(email, password) {

	try {

		const response = await signIn({
			username: email,
			password: password
		});

		// MFA required
		if (response.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE") {
			return {
				mfaRequired: true,
				nextStep: response.nextStep
			};
		}

		// Login completed
		localStorage.setItem("isAuthenticated", "true");

		const session = await fetchAuthSession();
		localStorage.setItem("userData", JSON.stringify(session.tokens?.idToken?.payload));

		return { success: true };

	} catch (e) {
		alert(e.message);
		throw e;
	}
}

async function confirmMFA(code) {
console.log("confirmMFA called with code:", code);
	try {

		const response = await confirmSignIn({
			challengeResponse: code
		});

		if (response.isSignedIn) {

			const session = await fetchAuthSession();

			localStorage.setItem(
				"userData",
				JSON.stringify(session.tokens?.idToken?.payload)
			);

			return { success: true };
		}

	} catch (e) {
		throw e;
	}
}
async function registerUser(props) {
	try {

		await signUp({
			username: props.user.username,
			password: props.user.password,
			options: {
				userAttributes: {
					email: props.user.username,
					name: `${props.user.foreName} ${props.user.surname}`,
				}
			}
		});

		props.history.push("/confirmRegister");

	} catch (e) {

		props.setisLoading(false);

		if (e.name === "InvalidPasswordException") {
			props.Seterrormsg({ authErr: MESSAGES.PASSWORD_RESTRICTION });

		} else if (e.name === "UsernameExistsException") {

			props.Seterrormsg({
				authErr:
					"An error is encountered while registering your account. Please contact service desk."
			});

		} else {

			props.Seterrormsg({ authErr: e.message });

		}
	}
}


async function confirmUser(props) {
	try {

		await confirmSignUp({
			username: props.user.username,
			confirmationCode: props.user.confirmationCode
		});

		props.history.push("/dashboard");

	} catch (e) {

		if (e.name === "InvalidParameterException") {
			props.Seterrormsg({ authErr: MESSAGES.CODE_RESTRICTION });

		} else {
			props.Seterrormsg({ authErr: e.message });
		}
	}
}


async function getSessionData() {

	const session = await fetchAuthSession();
console.log(session,"session")
	return session;
}


const isUserLoggedIn = async () => {
	try {

		await getCurrentUser();
		return true;

	} catch (error) {

		return false;
	}
};


export {
	loginUser,
	registerUser,
	confirmUser,
	getSessionData,
	isUserLoggedIn,
	confirmMFA,
};